import accounting from './accounting';
import entity from './entity';
import expenses from './expenses';
import generalLedgers from './general-ledgers';
import inventory from './inventory';
import invoices from './invoices';
import payroll from './payroll';
import progressReports from './progress-reports';
import taxes from './taxes';

let messages = Object.assign({}, accounting, entity, expenses, generalLedgers, inventory, invoices, payroll, progressReports, taxes);

export default messages;
